/**
 * System available languages
 */
export const LANGUAGES = [
    {
        value: 'pt-BR',
        label: 'PT',
        key: 'pt-BR',
    },
    {
        value: 'en-EN',
        label: 'EN',
        key: 'en-EN',
    },
    {
        value: 'es-ES',
        label: 'ES',
        key: 'es-ES',
    },
];

/**
 * Defines department type
 */
export const DEPARTMENTS = {
    DEPARTMENT_TYPE_YOUTH: '4', // Juvenil
    DEPARTMENT_TYPE_WHEELCHAIR: '3', // Cadeirantes
    DEPARTMENT_TYPE_SENIOR: '5', // Senior
    DEPARTMENT_TYPE_PROFESSIONAL: '12', // Professional
    DEPARTMENT_TYPE_CLASSES: '1', // Classes
    DEPARTMENT_TYPE_COACHTRAINING: '13', // Capacitação
    DEPARTMENT_TYPE_ARBITRATION: '14', // Arbitragem
    DEPARTMENT_TYPE_INSTITUTIONAL: '10', // Institucional
    DEPARTMENT_TYPE_UNIVERSITY: '9', // Universitário
    DEPARTMENT_TYPE_ENTITY: '16', // Entidade
    DEPARTMENT_TYPE_BEACHTENNIS: '2', // Beachtennis
    DEPARTMENT_TYPE_KIDS: '7', // Kids
    DEPARTMENT_TYPE_SERVICES: '21', // Services
    DEPARTMENT_TYPE_COURTS: '22', // Courts
    DEPARTMENT_TYPE_TENNIS10: '6', // Tennis 10
    DEPARTMENT_TYPE_BANANABOWL: '20', // Bananabowl
    DEPARTMENT_TYPE_WTN: '24', // World Tennis Number
    DEPARTMENT_TYPE_FAQ: '30', // FAQ
    DEPARTMENT_TYPE_DEVELOPMENT: '25', // Desenvolvimento
};

export const {
    DEPARTMENT_TYPE_YOUTH,
    DEPARTMENT_TYPE_WHEELCHAIR,
    DEPARTMENT_TYPE_SENIOR,
    DEPARTMENT_TYPE_PROFESSIONAL,
    DEPARTMENT_TYPE_CLASSES,
    DEPARTMENT_TYPE_COACHTRAINING,
    DEPARTMENT_TYPE_ARBITRATION,
    DEPARTMENT_TYPE_INSTITUTIONAL,
    DEPARTMENT_TYPE_UNIVERSITY,
    DEPARTMENT_TYPE_ENTITY,
    DEPARTMENT_TYPE_BEACHTENNIS,
    DEPARTMENT_TYPE_KIDS,
    DEPARTMENT_TYPE_SERVICES,
    DEPARTMENT_TYPE_COURTS,
    DEPARTMENT_TYPE_TENNIS10,
    DEPARTMENT_TYPE_BANANABOWL,
    DEPARTMENT_TYPE_WTN,
    DEPARTMENT_TYPE_DEVELOPMENT,
    DEPARTMENT_TYPE_FAQ,
} = DEPARTMENTS;

/**
 * Helper function
 * TODO: Mover
 */
export const getDepartmentTypeByRouteName = (route) => {
    const departmentRouteType = {
        classes: '1',
        beachtennis: '2',
        wheelchair: '3',
        youth: '4',
        senior: '5',
        kids: '7',
        university: '9',
        institutional: '10',
        professional: '12',
        coachtraining: '13',
        arbitration: '14',
        entity: '16',
        services: '21',
        courts: '22',
        tennis10: '6',
        bananabowl: '20',
        development: '25',
        wtn: '24',
        faq: '30',
    };
    return departmentRouteType[route];
};

/**
 * Defines department type name of route
 */
// Juvenil
export const DEPARTMENT_PATH_YOUTH = 'youth';
// Cadeirantes
export const DEPARTMENT_PATH_WHEELCHAIR = 'wheelchair';
// Senior
export const DEPARTMENT_PATH_SENIOR = 'senior';
// Professional
export const DEPARTMENT_PATH_PROFESSIONAL = 'professional';
// Classes
export const DEPARTMENT_PATH_CLASSES = 'classes';
// Capacitação
export const DEPARTMENT_PATH_COACHTRAINING = 'coachtraining';
// Arbitragem
export const DEPARTMENT_PATH_ARBITRATION = 'arbitration';
// Institucional
export const DEPARTMENT_PATH_INSTITUTIONAL = 'institutional';
// Universitário
export const DEPARTMENT_PATH_UNIVERSITY = 'university';
// Entidade
export const DEPARTMENT_PATH_ENTITY = 'entity';
// Beachtennis
export const DEPARTMENT_PATH_BEACHTENNIS = 'beachtennis';
// Kids
export const DEPARTMENT_PATH_KIDS = 'kids';
// services
export const DEPARTMENT_PATH_SERVICES = 'services';
// courts
export const DEPARTMENT_PATH_COURTS = 'courts';
// Tennis10
export const DEPARTMENT_PATH_TENNIS10 = 'tennis10';
// Bananabowl
export const DEPARTMENT_PATH_BANANABOWL = 'bananabowl';
// wtn
export const DEPARTMENT_PATH_WTN = 'wtn';
// wtn
export const DEPARTMENT_PATH_FAQ = 'faq';
// Desenvolvimento
export const DEPARTMENT_PATH_DEVELOPMENT = 'development';

export const positions = {
    MAIN_SCREEN: 1,
    MAIN_PAGE: 2,
    NEWS_START: 3,
    NEWS_END: 4,
    DEPARTMENT_SIDEBAR: 5,
    TOURNAMENTS: 6,
    DEPARTMENT_HEADER: 7,
    FEDERATION: 8,
    CLUBS: 9,
    CONTACT: 10,
};

export const formatTypes = {
    BNTENNISTOOL01: 1,
    BNTENNISTOOL02: 2,
    BNTENNISTOOL03: 3,
    BNTENNISTOOL04: 4,
    BNTENNISTOOL05: 5,
};
